import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { MspAlertSummary as MspAlertSummaryType } from "@/types/api";

interface MspAlertSummaryProps {
  summary: MspAlertSummaryType[];
  isLoading: boolean;
}

export function MspAlertSummary({ summary, isLoading }: MspAlertSummaryProps) {
  const totals = summary.reduce(
    (acc, s) => ({
      critical: acc.critical + s.critical,
      high: acc.high + s.high,
      medium: acc.medium + s.medium,
      low: acc.low + s.low,
    }),
    { critical: 0, high: 0, medium: 0, low: 0 },
  );

  const total = totals.critical + totals.high + totals.medium + totals.low;

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i}>
            <CardContent className="p-4">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="mt-2 h-8 w-12" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">Total Alerts</p>
          <p className="mt-1 text-2xl font-bold">{total}</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">Critical</p>
          <p className="mt-1 text-2xl font-bold text-red-400">
            {totals.critical}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">High</p>
          <p className="mt-1 text-2xl font-bold text-orange-400">
            {totals.high}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <p className="text-sm text-muted-foreground">Medium</p>
          <p className="mt-1 text-2xl font-bold text-yellow-400">
            {totals.medium}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
